import React, { FC, useCallback, useEffect } from 'react';

import { Button } from '@yandex-360/orb-components/dist/components/Button';
import { Empty } from '@yandex-360/orb-components/dist/components/Empty';
import { useSelector } from 'react-redux';

import { SvgImage } from '../../shared/components';
import { actualizeTeleMessengerUrlAction } from '../../shared/features/config';
import { isMobileUa } from '../../shared/features/uatraits';
import { i18n } from '../../shared/helpers/i18n';
import { useActions } from '../../shared/hooks';
import { useAppStoreLink } from '../../shared/hooks/useAppStoreLink';
import styles from './styles.css';

export interface TeleMessengerPlaceholderPageProps {
    redirectUrl: string;
}

export const TeleMessengerPlaceholderPage: FC<TeleMessengerPlaceholderPageProps> = ({ redirectUrl }) => {
    const isMobile = useSelector(isMobileUa);
    const { actualizeTeleMessengerUrl } = useActions({
        actualizeTeleMessengerUrl: actualizeTeleMessengerUrlAction,
    });
    const storeLink = useAppStoreLink();

    useEffect(() => {
        actualizeTeleMessengerUrl();
    }, [actualizeTeleMessengerUrl]);

    const openStore = useCallback(() => {
        if (storeLink) {
            window.location.assign(storeLink);
        }
    }, [storeLink]);

    if (!isMobile) {
        return null;
    }

    return (
        <div className={styles.container}>
            <Empty
                className={styles.stub}
                content={<SvgImage imageName="teleMessengerPlaceholder" withUniqueUrls={false} />}
                title={i18n('telemessenger-placeholder', 'you-have-been-invited-to-telemost-chat')}
                description={i18n('telemessenger-placeholder', 'install-telemost-motivation-text')}
            />
            <div className={styles.actionBar}>
                <Button elementType="a" href={storeLink} view="brand" size="lg" onPress={openStore}>
                    {i18n('telemessenger-placeholder', 'install-telemost')}
                </Button>
                <Button elementType="a" href={redirectUrl} view="neutral" size="lg">
                    {i18n('telemessenger-placeholder', 'continue-in-browser')}
                </Button>
            </div>
        </div>
    );
};
